import { KEYS } from '@udecode/plate';

export const getCommentKey = (id: string) => `${KEYS.comment}_${id}`;
